"use client"
/* */
import { useSelector } from '../../../../lib/mobx/useSelector.mjs';
import { makeObservable, action, computed, observable } from 'mobx';
import { useStatic } from '../../../../lib/hooks/useStatic.mjs';

class IncrementalLoaderState {
  dataBatches = [];
  prevDataBatches = [];
  batchLoadingStates = ["void"];
  constructor() {
    makeObservable(this, {
      prevDataBatches: false,
      useMergedData: false,
      useIsLoading: false,
      dataBatches: observable.shallow,
      batchLoadingStates: observable.shallow,
      mergedData: computed,
      isLoading: computed,
      reset: action.bound,
      setDataBatch: action.bound,
      setBatchLoadingState: action.bound
    });
  }
  static useNew() {
    return useStatic(() => new IncrementalLoaderState());
  }
  reset() {
    this.batchLoadingStates = [];
    this.dataBatches = [];
  }
  setDataBatch(index, data) {
    if (this.dataBatches.length === 0) {
      this.prevDataBatches = [];
    }
    if (this.dataBatches[index] !== data) {
      this.dataBatches[index] = data;
      this.prevDataBatches[index] = data;
    }
  }
  setBatchLoadingState(index, state) {
    if (this.batchLoadingStates[index] !== state) {
      this.batchLoadingStates[index] = state;
    }
  }
  get mergedData() {
    const dataBatches = this.dataBatches.length === 0 ? this.prevDataBatches : this.dataBatches;
    return dataBatches.flatMap((d) => d);
  }
  useMergedData() {
    return useSelector(() => this.mergedData, [this.prevDataBatches]);
  }
  get isLoading() {
    return this.batchLoadingStates.some((s) => s === "loading" || s === "void");
  }
  useIsLoading() {
    return useSelector(() => this.isLoading);
  }
  isBatchLoaded(batchIndex) {
    return batchIndex in this.dataBatches;
  }
}

export { IncrementalLoaderState };
//# sourceMappingURL=IncrementalLoaderState.mjs.map
